import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const toggleFavouritesSignal = async ({ object_id, content_type }) => {
  try{
    const data = { object_id, content_type };
    const url = `${backendUrl}/api/reactions/bookmarks/create/`;
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при добавление/удаление избранного: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка добавления/удаления избранного:', error);
    throw error;
  }
};